import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useAIRoleBuilderTasksContext, useModalConfirmation } from "hooks";
import { AI_ROLE_BUILDER_TASK_DISPLAY_STATE as DISPLAY_STATE, getRoleBuilderTaskDisplayState } from "constants/index";
import { taskDisplayName } from "components/Missions/Roles/AIRoleBuilder/AIRoleBuilderTasksList";

export default function useAIRoleBuilderTasks() {
  const { discardTask } = useAIRoleBuilderTasksContext();
  const { show } = useModalConfirmation();

  // Discarding an in-flight request is unrecoverable: the data service has no cancel
  // endpoint, so the result is dropped and re-requesting costs another agent run.
  // Terminal requests are discarded without a prompt.
  const handleDiscard = useCallback(
    async (task) => {
      if (getRoleBuilderTaskDisplayState(task) === DISPLAY_STATE.PROCESSING) {
        const confirmed = await show(
          <FormattedMessage id="AIRoleBuilder.Tasks.Discard.Confirm.Title" />,
          <FormattedMessage
            id="AIRoleBuilder.Tasks.Discard.Confirm.Description"
            values={{ label: taskDisplayName(task) }}
          />
        );

        if (!confirmed) return;
      }

      discardTask(task.id);
    },
    [discardTask, show]
  );

  return { handleDiscard };
}
